<template>
  <div id="LmFormBuilder" class="wrapper-content w-100">
    <h1 v-if="pageTitleData">{{pageTitleData}}</h1>
    <LmForm ref="lmFormRef">
      <template v-for="(formRow, index) in formElements">
        <component
          v-if="formRow.componentName !== 'LmButton'"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          v-bind="formRow.componentProps"
          :v="$v.formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          v-model="formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :model="loadSuperPowerId(formObjectToSendToServer[formRow.formObjectToSendToServerProperty], formRow.componentName, formRow.componentProps)"
          @click.native="click(formRow)"
          @values="updateLmSuperPower($event, formRow.formObjectToSendToServerProperty, formRow.componentProps)"
        />
        <component
          v-if="formRow.componentName === 'LmButton'"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          v-bind="formRow.componentProps"
          @click.native="click(formRow)"
        />
      </template>
    </LmForm>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  numeric
  // requiredIf
} from 'vuelidate/lib/validators'

import commonsApi from '@/api/commons'

import LmForm from '@/components/form/LmForm'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmDate from '@/components/form/elements/LmDate'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmFormSubtittles from '@/components/form/elements/LmFormSubtittles'
import LmFormSeparator from '@/components/form/elements/LmFormSeparator'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

export default {
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmEmailInput,
    LmNumberInput,
    LmTextArea,
    LmSelect,
    LmFormSubtittles,
    LmFormSeparator,
    LmDate,
    LmDateTime,
    LmSuperPowerSelect
  },
  data () {
    return {
      pageTitleData: '',
      formObjectToSendToServer: {},
      formElements: [],
      validationsData: {}
    }
  },
  validations () {
    const validationsRules = {
      formObjectToSendToServer: {}
    }
    for (const property in this.validationsData) {
      validationsRules.formObjectToSendToServer[property] = {}
      for (const innerObjectProperty in this.validationsData[property]) {
        switch (innerObjectProperty) {
          case 'required':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = required
            break
          case 'email':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = email
            break
          case 'minLength':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = minLength(this.validationsData[property][innerObjectProperty])
            break
          case 'maxLength':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = maxLength(this.validationsData[property][innerObjectProperty])
            break
          case 'numeric':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = numeric
            break
          case 'id':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = {
              id: required
            }
            break

          default:
            break
        }
      }
    }
    return validationsRules
  },
  props: {
    endpointUriwhereGetComponents: {
      type: String,
      default: '',
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    endpointUriWhereGetValuesToLoadInEditMode: {
      type: String,
      default: ''
    }
  },
  methods: {
    loadSuperPowerId (model, componentName, componentProps) {
      if (componentName === 'LmSuperPowerSelect') {
        if (componentProps.multiple) {
          const getIdsFromDataSuperPower = model.map((el) => el.id)
          return getIdsFromDataSuperPower.join()
        } else {
          return model.id ? model.id.toString() : ''
        }
      }
    },
    updateLmSuperPower (values, formObjectToSendToServerProperty, componentProps) {
      if (componentProps.multiple) {
        this.formObjectToSendToServer[formObjectToSendToServerProperty] = values
      } else {
        let value = values[0]
        this.formObjectToSendToServer[formObjectToSendToServerProperty].id = value ? value.id : null
        this.formObjectToSendToServer[formObjectToSendToServerProperty].name = value ? value.name : null
      }
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: this.endpointUriWhereGetValuesToLoadInEditMode,
          id: this.$route.params.id
        }, 'formObjectToSendToServer')
      }
    },
    async click (formRow) {
      if (formRow?.actions) {
        switch (formRow?.actions?.click?.type) {
          case 'submit':
            await this.$refs.lmFormRef.validationForm(this.$v)
            console.log('this.formObjectToSendToServer', this.formObjectToSendToServer)
            await commonsApi.axiosPostWrapper(formRow?.actions?.click?.arguments?.path, this.formObjectToSendToServer)
            break
          case 'cancel':
            console.log('cancel')
            break
          default:
            break
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.setForm()
    }, 50)
  },
  async created () {
    const endPoint = await commonsApi.axiosGetWrapper(this.endpointUriwhereGetComponents)
    this.pageTitleData = endPoint.data.pageTitleData
    this.formElements = endPoint.data.formElements
    this.validationsData = endPoint.data.validations
    this.formElements.forEach((component, index) => {
      if (component.formObjectToSendToServerProperty) {
        this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, '')
      }
      if (component.componentName === 'LmSuperPowerSelect') {
        this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, { id: '', name: '' })
      }
      if (component.componentName === 'LmSuperPowerSelect' && component?.componentProps.multiple) {
        this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, [])
      }
      if (
        (component.componentName === 'LmDate' || component.componentName === 'LmDateTime') &&
        this.formElements[index].componentProps &&
        this.formElements[index].componentProps.config
      ) {
        this.formElements[index].componentProps.config.locale = Spanish
      }
    })
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  .form-wrapper
    margin-right: -15px
    margin-left: -15px
  #form
    display: -ms-flexbox
    display: -webkit-box
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    width: 100%
</style>
